<template>
  <b-card no-body :class="{ 'card-transparent-background my-0 pt-0': type == 'view' || type == 'edit' }">
    <b-card-body :class="{
        'p-2': type == 'register',
        'p-0': type == 'view' || type == 'edit',
      }">

      <div class="container" :class="{
          'mx-0': type == 'view' || type == 'edit',
        }">
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" label="LinkedIn" label-for="linkedin" :linkedin="linkedin"
              label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
              :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
              :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
              :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
              <b-form-input v-if="type == 'register' || type == 'edit'" id="linkedin" name="linkedin" class="form-control-garden-help"
                v-model="_linkedin" :linkedin="linkedin" placeholder="" ></b-form-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _linkedin }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" label="Facebook" label-for="facebook" :facebook="facebook"
              label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
              :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
              :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
              :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
              <b-form-input v-if="type == 'register' || type == 'edit'" id="facebook" name="facebook" class="form-control-garden-help"
                v-model="_facebook" :facebook="facebook" placeholder="" ></b-form-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _facebook }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" label="Website Adress" label-for="website" :website="website"
              label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
              :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
              :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
              :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
              <b-form-input v-if="type == 'register' || type == 'edit'" id="website" name="website" class="form-control-garden-help"
                v-model="_website" :website="website" placeholder="" ></b-form-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _website }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>


<script>
export default {
  name: "SocialMediaInfo",
  components: {},
  props: ["type", "linkedin", "facebook", "website"],
  data() {
    return {};
  },
  updated() { },
  mounted() { },
  computed: {
    _linkedin: {
      get() {
        return this.linkedin;
      },
      set(value) {
        this.$emit("update:linkedin", value);
      },
    },

    _facebook: {
      get() {
        return this.facebook;
      },
      set(value) {
        this.$emit("update:facebook", value);
      },
    },
    _website: {
      get() {
        return this.website;
      },
      set(value) {
        this.$emit("update:website", value);
      },
    },
  },
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/SocialMediaInfo.vue